import { httpRequest } from '@/utils/request'
import { CommonResponse, TableRequestType, TableReponseType } from '@/types'

export type ForwardTargetType = 'mqtt' | 'tcp' | 'ntrip_server' | 'ntrip_client'

export interface ForwardRule {
  id: string
  name: string
  description?: string
  device_id: string
  product_id?: string
  status: 'enabled' | 'disabled'
  trigger_type: string
  target_type: ForwardTargetType
  target_config: Record<string, any>
  sync_status: string
  created: number
  modified: number
}

export interface CreateForwardRuleData {
  name: string
  description?: string
  device_id: string
  trigger_type: 'all'
  trigger_config: Record<string, any>
  target_type: ForwardTargetType
  target_config: Record<string, any>
  data_format?: 'json'
}

export function getForwardRules (params: TableRequestType & {
  device_id?: string
  target_type?: ForwardTargetType
  status?: string
}) {
  return httpRequest<any, CommonResponse<TableReponseType<ForwardRule>>>({
    url: '/api/v1/forward/rules',
    method: 'get',
    params,
  })
}

export function getForwardRuleById (ruleId: string) {
  return httpRequest<any, CommonResponse<ForwardRule>>({
    url: `/api/v1/forward/rule/${ruleId}`,
    method: 'get',
  })
}

export function createForwardRule (data: CreateForwardRuleData) {
  return httpRequest<any, CommonResponse<{ rule_id: string }>>({
    url: '/api/v1/forward/rule',
    method: 'post',
    data,
  })
}

export function updateForwardRule (ruleId: string, data: Partial<CreateForwardRuleData>) {
  return httpRequest<any, CommonResponse<{ rule_id: string }>>({
    url: `/api/v1/forward/rule/${ruleId}`,
    method: 'put',
    data,
  })
}

export function deleteForwardRule (ruleId: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/forward/rule/${ruleId}`,
    method: 'delete',
  })
}

export function enableForwardRule (ruleId: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/forward/rule/${ruleId}/enable`,
    method: 'post',
  })
}

export function disableForwardRule (ruleId: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/forward/rule/${ruleId}/disable`,
    method: 'post',
  })
}

export function syncForwardRule (ruleId: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/forward/rule/${ruleId}/sync`,
    method: 'post',
  })
}
